import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import _ from 'lodash'

const MaterialItem = ({ material, onItemSelected }) => {
  return (
    <div style={styles.item} onClick={() => onItemSelected(material)}>
      <div style={styles.itemsLabel}>{ material.name }</div>
      { material.cost && <div>${ material.cost }</div> }
    </div>
  )
}

MaterialItem.propTypes = {
  material: PropTypes.object.isRequired,
  onItemSelected: PropTypes.func.isRequired
}

class MaterialsList extends React.Component {

  static propTypes = {
    searchTerm: PropTypes.string.isRequired,
    defaultMaterials: PropTypes.object,
    onItemSelected: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      materialsDataSource: this.getMaterialsDataSource(this.props)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.defaultMaterials !== nextProps.defaultMaterials) {
      this.setState({
        materialsDataSource: this.getMaterialsDataSource(nextProps)
      })
    }
  }

  getMaterialsDataSource = props => {
    const value = props.defaultMaterials
    const materialsDataSource = value
      ? _.map(value)
      : []
    return materialsDataSource
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.materialsLabel}>Materials</div>
        <div style={styles.scroll}>
          <div style={styles.materialsContainer}>
            { this.state.materialsDataSource
              .filter(material => material.name.toLowerCase().indexOf(this.props.searchTerm.toLowerCase()) >= 0)
              .map((material, index) =>
                <MaterialItem
                  key={index}
                  material={material}
                  onItemSelected={this.props.onItemSelected} />)
            }
          </div>
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    border: '1px solid #e2e2e2',
    maxHeight: 250
  },
  scroll: {
    overflow: 'auto',
    width: 300
  },
  materialsContainer: {
    marginTop: 7,
    marginBottom: 7
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#494949',
    fontSize: 14,
    cursor: 'pointer',
    marginLeft: 24,
    marginRight: 15,
    marginBottom: 10
  },
  materialsLabel: {
    color: '#494949',
    fontSize: 14,
    paddingLeft: 15,
    marginTop: 8,
    marginBottom: 8
  },
  itemsLabel: {
    color: '#494949',
    fontSize: 14
  }
}

const mapStateToProps = state => ({
  defaultMaterials: state.firebase.team.defaultMaterials.value
})

export default connect(mapStateToProps)(MaterialsList)



// WEBPACK FOOTER //
// ./src/billing/common/modules/items/MaterialsList.js